import _isEmpty from 'lodash/isEmpty';
export function ensureTrailingSlash(slug) {
  if (!slug) {
    return '/';
  }
  if (!slug.endsWith('/')) {
    return "".concat(slug, "/");
  }
  return slug;
}
export function cleanSlug(slug) {
  if (!slug) {
    return '';
  }
  return slug.replace(/^\/+|\/+$/g, '');
}
export function addSlashToPath() {
  var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (_isEmpty(paths)) {
    return '';
  }
  var finalPath = paths.map(function (path) {
    var cleanedPath = cleanSlug(path);
    return "/".concat(cleanedPath);
  }).join('');
  return ensureTrailingSlash(finalPath);
}